import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";
import type { ReactNode } from "react";

interface PrivateRouteProps {
    children: ReactNode;
}

export default function PrivateRoute({ children }: PrivateRouteProps) {
    const location = useLocation();

    // Ambil status langsung dari Context (Memory/LocalStorage)
    // Ini instan, tidak perlu menunggu request server
    const { user, loading } = useAuth();

    // 1. Tunggu inisialisasi Context selesai (baca localStorage)
    if (loading) {
        return (
            <div className="w-full h-screen flex flex-col items-center justify-center bg-slate-50 dark:bg-slate-900">
                <div className="h-10 w-10 animate-spin rounded-full border-4 border-slate-300 border-t-blue-600"></div>
                <p className="mt-4 text-sm text-slate-500 animate-pulse">Memuat data pengguna...</p>
            </div>
        );
    }

    // 2. Jika USER TIDAK ADA (Belum Login) → Tendang ke Login
    if (!user) {
        // 'state={{ from: location }}' berguna agar setelah login user dikembalikan ke halaman ini
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    // 3. Jika User Ada → Silakan masuk
    return <>{children}</>;
}